import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GlobalVariable } from '../services/global-variable/global-variable';

export const offerAccessGuardGuard: CanActivateFn = (route, state) => {
  const router = inject(Router)
  const globalVariableService = inject(GlobalVariable)

  // if queryParms match the "set global var offer_id" then continue
  // else no access and return user back to home
  // if user does a browser refresh they are taken back home
  // if user enters their own "offer_id" or and old "offer_id" they wouldn't have accesss

  if (route?.queryParams['offer_id'] === globalVariableService?.offerId) {
    return true;
  }
  
  router.navigate(['/'])
  return false
};
